import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TableConfig,TableRow } from '../../interface/table-column'; // Adjust the import path as necessary
interface PageEvent {
  first: number;
  rows: number;
  page: number;
  pageCount: number;
}
@Component({
  selector: 'app-data-grid',
  templateUrl: './data-grid.component.html',
  styleUrl: './data-grid.component.scss',
  standalone: false,
})
export class DataGridComponent {
  @Input() config!: TableConfig;
  tableRow: TableRow[] = [];
  paginatorDropdownOptions = [5, 10, 20, 30, 50];

  @Output() actionTriggered = new EventEmitter<{ action: string; row: any }>();

  checked: boolean = false;
  @Input() totalRecords: number = 0;
  rows: number = 10; // page size
  first = 0;
  rowsPerPageOptions = [5, 10, 20, 50];

  getAllKeys(rows: any[]): string[] {
    const allKeys = new Set<string>();
    rows.forEach((row) => {
      Object.keys(row).forEach((key) => allKeys.add(key));
    });
    return Array.from(allKeys);
  }

  onAction(action: string, row: any) {
    console.log(action, row);
    this.actionTriggered.emit({ action, row });
  }

  loadData(event: any) {
    const start = event.first;
    const end = start + event.rows;
    this.tableRow = this.config.rows.slice(start, end);
  }

  onPageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }
}
